import { render, staticRenderFns } from "./NswUserResetPassword.vue?vue&type=template&id=2e7452b1&scoped=true"
import script from "./NswUserResetPassword.vue?vue&type=script&lang=js"
export * from "./NswUserResetPassword.vue?vue&type=script&lang=js"
import style0 from "./NswUserResetPassword.vue?vue&type=style&index=0&id=2e7452b1&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7452b1",
  null
  
)

export default component.exports